import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const ESGChatHistoryAction = createAsyncThunk("esgChatHistory",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.esgChatHistory, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const ESGChatHistorySlice = createSlice({
    name: "esgChatHistory",
    initialState: {
        isLoading: false,
        data: false,
        success: false,
        error: null
    },
    reducers: {
        EsgChatHistoryReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ESGChatHistoryAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ESGChatHistoryAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ESGChatHistoryAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { EsgChatHistoryReset } = ESGChatHistorySlice.actions
export default ESGChatHistorySlice.reducer